module.exports = __webpack_public_path__ + "static/img/cont44_02.a1fab61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_02.jpg
// module id = hTUz
// module chunks = 0